import React from 'react';
import { Box, Paper, Skeleton } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useNavigate } from 'react-router-dom';
import { GoChevronLeft } from 'react-icons/go';

export default function LocationFormSkeleton() {
  const navigate = useNavigate();

  return (
    <Box component='form'>
      {/* Header with Back Button */}
      <Box display='flex' alignItems='start' mb={3} gap={0.8}>
        <Box
          onClick={() => navigate(-1)}
          display='flex'
          alignItems='center'
          justifyContent='center'
          border='1px solid #1976d2'
          borderRadius='50%'
          mt={0.6}
          width={22}
          height={22}
          sx={{ cursor: 'pointer', bgcolor: '#fff' }}
        >
          <GoChevronLeft color='#1976d2' />
        </Box>
        <Skeleton variant='text' width={150} height={32} />
      </Box>

      {/* Main Form Paper */}
      <Paper
        elevation={0}
        sx={{
          backgroundColor: '#fff',
          borderRadius: '12px',
          p: 3
        }}
      >
        {/* Physical Location Section */}
        <Box>
          <Skeleton variant='text' width={150} height={24} sx={{ mb: 1 }} />
          <Box display='flex' gap={2} mb={2}>
            <Skeleton variant='rectangular' width={60} height={20} sx={{ borderRadius: 1 }} />
            <Skeleton variant='rectangular' width={40} height={20} sx={{ borderRadius: 1 }} />
          </Box>

          {/* Basic Information Grid */}
          <Grid container spacing={2} mt={1}>
            <Grid size={{ xs: 12, md: 6 }}>
              <Skeleton variant='text' width={120} height={20} sx={{ mb: 1 }} />
              <Skeleton variant='rectangular' width='100%' height={56} sx={{ borderRadius: 1 }} />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <Skeleton variant='text' width={100} height={20} sx={{ mb: 1 }} />
              <Skeleton variant='rectangular' width='100%' height={56} sx={{ borderRadius: 1 }} />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <Skeleton variant='text' width={60} height={20} sx={{ mb: 1 }} />
              <Skeleton variant='rectangular' width='100%' height={56} sx={{ borderRadius: 1 }} />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <Skeleton variant='text' width={120} height={20} sx={{ mb: 1 }} />
              <Skeleton variant='rectangular' width='100%' height={56} sx={{ borderRadius: 1 }} />
            </Grid>
          </Grid>

          {/* Address Information Section */}
          <Skeleton variant='text' width={150} height={24} sx={{ mt: 4, mb: 1 }} />

          {/* Address Fields Grid */}
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, md: 6 }}>
              <Skeleton variant='text' width={100} height={20} sx={{ mb: 1 }} />
              <Skeleton variant='rectangular' width='100%' height={56} sx={{ borderRadius: 1 }} />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <Skeleton variant='text' width={100} height={20} sx={{ mb: 1 }} />
              <Skeleton variant='rectangular' width='100%' height={56} sx={{ borderRadius: 1 }} />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <Skeleton variant='text' width={60} height={20} sx={{ mb: 1 }} />
              <Skeleton variant='rectangular' width='100%' height={56} sx={{ borderRadius: 1 }} />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <Skeleton variant='text' width={120} height={20} sx={{ mb: 1 }} />
              <Skeleton variant='rectangular' width='100%' height={56} sx={{ borderRadius: 1 }} />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <Skeleton variant='text' width={80} height={20} sx={{ mb: 1 }} />
              <Skeleton variant='rectangular' width='100%' height={56} sx={{ borderRadius: 1 }} />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <Skeleton variant='text' width={150} height={20} sx={{ mb: 1 }} />
              <Skeleton variant='rectangular' width='100%' height={56} sx={{ borderRadius: 1 }} />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <Skeleton variant='text' width={100} height={20} sx={{ mb: 1 }} />
              <Skeleton variant='rectangular' width='100%' height={56} sx={{ borderRadius: 1 }} />
            </Grid>
          </Grid>

          {/* Grant Access Section */}
          <Skeleton variant='text' width={120} height={24} sx={{ mt: 4, mb: 1 }} />
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, md: 6 }}>
              <Skeleton variant='text' width={150} height={20} sx={{ mb: 1 }} />
              <Skeleton variant='rectangular' width='100%' height={56} sx={{ borderRadius: 1 }} />
            </Grid>
          </Grid>

          {/* Business Hours Section */}
          <Grid container>
            <Grid size={{ xs: 12 }}>
              <Skeleton variant='text' width={120} height={24} sx={{ mt: 2, mb: 1 }} />
              <Skeleton variant='rectangular' width='100%' height={200} sx={{ borderRadius: 1 }} />
            </Grid>
          </Grid>
        </Box>
      </Paper>

      {/* Submit Button */}
      <Box display='flex' flexDirection='row' gap={1} justifyContent='end'>
        <Skeleton variant='rectangular' width={140} height={40} sx={{ mt: 4, borderRadius: 1 }} />
      </Box>
    </Box>
  );
}
